<template>
    <div class="popup-page" id="popup-page">
        <div class="popup-main">
            <img class="popup" src="../../../assets/images/components/img_loading.png" alt=""/>
            <div class="popup-content">
                <span>本产品为</span>
                <b>深圳市慧择保险</b>
                <span><b>经纪</b>提供</span>
            </div>
            <div class="popup-time">{{ timerTxt }}</div>
        </div>
    </div>
</template>
<script>
    import
    {
        bridgeRedirect,
        callHandler
    } from "../../../utils/bridge";
    import sensors from "sa-sdk-javascript";

    export default {
        name: "loadingXSBX",
        data() {
            return {
                provider: "",
                timerTxt: "02 sec"
            };
        },
        mounted() {
            sensors.track("TMInsure");
            let params = this.$route.query;
            const {target} = params;
            this.target = target && decodeURIComponent(target);
            this.showtime(2);
        },
        methods: {
            showtime(t) {
                for (let i = 1; i < t + 1; i++) {
                    window.setTimeout(() => {
                        if (i === t) {
                            if (this.target) {
                                bridgeRedirect({
                                    pageParams: {
                                        url: `${this.target}`,
                                        login: "1",
                                        isNeedToken: "0",
                                        isNeedRemoveWebView: "1",
                                        "module": "QiXinWebView"
                                    }
                                });
                            } else {
                                callHandler("xhWapGoBack", "wapCloseWeb");
                            }
                        }
                        this.timerTxt = "0" + (t - i) + " sec";
                    }, i * 1000);
                }
            }
        }
    };
</script>
<style lang="less">
    @import "../css/loading.less";
</style>
